import Loader from "../loader";
import "./styles.css";

export const IconButton = (props) => {
  const {
    onClick,
    color = "text-white",
    width = "w-[358px] lg:w-[384px] max-[400px]:w-[100%]",
    disabled = false,
    icon,
  } = props || {};
  return (
    <div
      className={`h-11 ${width} gradient ${
        disabled ? "opacity-50" : ""
      } rounded-lg items-center justify-center flex`}
    >
      {disabled ? (
        <Loader stroke="text-[#fff]" />
      ) : (
        <button
          onClick={onClick}
          className={`${width}  ${color}  h-11 font-semibold text-base  flex flex-row justify-center items-center`}
          disabled={disabled}
        >
          <img src={icon} alt="" className="w-4 h-4" />
        </button>
      )}
    </div>
  );
};
